import store from './store'
import {Model} from '../types/Model'
import {ActiveSimulations} from '../types/ActiveSimulations'
import {openAlertSystemLayer} from './layers/launchers/AlertSystemLayerHandle'
import axios from 'axios'
import {
    setFetchActiveSimulations,
    setFetchModels,
} from '../features/configurationsModelsData/configurationModelsDataSlice'
import {setLoading} from '../features/general/generalSlice'
import {
    setDealerOptions,
    setProvinces,
} from '../features/dealerFormData/dealerFormDataSlice'
import {AllowedUrlParams} from '../types/AllowedUrlParams'
import {createAsyncThunk} from '@reduxjs/toolkit'
import {Global} from '../shared/variables'

export const fetchData = async () => {
    const getModelsPromise = axios.get<Model[]>(
        `${store.getState().general.backendUrl}/api/get_models/${
            store.getState().general.serviceType
        }${
            store.getState().general.previewDateParam
                ? Global.QUESTION_MARK +
                  Global.PREVIEW_DATE +
                  '=' +
                  store.getState().general.previewDateParam
                : ''
        }`
    )

    const getActiveSimulationsPromise = axios.get<ActiveSimulations>(
        `${store.getState().general.backendUrl}/api/get_active_simulations/${
            store.getState().general.serviceType
        }${
            store.getState().general.previewDateParam
                ? Global.QUESTION_MARK +
                  Global.PREVIEW_DATE +
                  '=' +
                  store.getState().general.previewDateParam
                : ''
        }`
    )

    const getProvinces = `${
        store.getState().general.backendUrl
    }/api/get_provinces/${store.getState().general.serviceType}`

    const getDealers = `${
        store.getState().general.backendUrl
    }/api/service_partners/${store.getState().general.serviceType}`

    store.dispatch(setLoading(true))

    try {
        const [modelsResponse, activeSimulationsResponse] = await Promise.all([
            getModelsPromise,
            getActiveSimulationsPromise,
        ])

        store.dispatch(setFetchModels(modelsResponse.data))
        store.dispatch(
            setFetchActiveSimulations(activeSimulationsResponse.data)
        )

        const provinces = await axios.get(getProvinces)
        store.dispatch(setProvinces(provinces.data))

        const dealers = await axios.get(getDealers)
        store.dispatch(setDealerOptions(dealers.data))
    } catch (error) {
        openAlertSystemLayer()
    } finally {
        store.dispatch(setLoading(false))
    }
}

export const getAllowedUrlParams = createAsyncThunk(
    'ctaAllowedParams/getAllowedUrlParams',
    async () => {
        try {
            const response = await axios.get<AllowedUrlParams>(
                `${store.getState().general.backendUrl}/api/configuration`
            )
            return response.data
        } catch (err) {
            openAlertSystemLayer()
            throw err
        }
    }
)

export type AppDispatch = typeof store.dispatch
